import { Table, Tooltip, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const { Text } = Typography;

function ReviewsTable({
  pagination,
  expandable,
  renderProductColumn,
  renderActionsColumn,
  renderReviewScoreColumn,
  loading,
  filteredProducts,
  rowSelection,
}) {
  const { t } = useTranslation();

  const columnsByMkt = [
    {
      title: 'SKU',
      ellipsis: true,
      dataIndex: ['defaultCode'],
      key: 'sku',
      width: '20%',
      render: (value) => (
        <Tooltip title={value}>
          <Text style={{ fontSize: 12 }}>{value}</Text>
        </Tooltip>
      ),
    },
    {
      title: t('catalogue.table.product'),
      dataIndex: ['title'],
      key: 'title',
      align: 'center',
      ellipsis: false,
      render: (value, record) => renderProductColumn(value, record),
    },
    {
      title: t('catalogue.table.score'),
      dataIndex: ['rating'],
      key: 'id',
      width: '12%',
      align: 'center',
      ellipsis: false,
      render: (value, record) => renderReviewScoreColumn(value, record),
    },
    {
      title: t('catalogue.table.reviewSettings'),
      ellipsis: true,
      dataIndex: ['actions'],
      key: 'actions',
      width: '20%',
      render: (value, record) => renderActionsColumn(value, record),
    },
  ];

  return (
    <Table
      rowKey={(record) => record.id}
      dataSource={filteredProducts}
      loading={loading}
      columns={columnsByMkt}
      pagination={pagination}
      expandable={{
        ...expandable,
      }}
      rowSelection={{
        ...rowSelection,
      }}
      showHeader
      scroll={{ y: '100%' }}
    />
  );
}

ReviewsTable.propTypes = {
  pagination: PropTypes.objectOf(Object).isRequired,
  expandable: PropTypes.objectOf(Object).isRequired,
  renderProductColumn: PropTypes.func.isRequired,
  renderActionsColumn: PropTypes.func.isRequired,
  renderReviewScoreColumn: PropTypes.func.isRequired,
  filteredProducts: PropTypes.instanceOf(Array).isRequired,
  loading: PropTypes.bool.isRequired,
  rowSelection: PropTypes.objectOf(Object).isRequired,
};

export default ReviewsTable;
